import {
  ClickAwayListener,
  MenuList,
  Paper,
  Popper,
  Slide,
  ListItemText,
} from '@material-ui/core'
import { forwardRef, useContext, useEffect, useRef } from 'react'
import { GlobalContext } from '../App'
import Notificacao from './Notificacao'

const Notificacoes = (
  { openNotificacao: open, setOpenNotificacao: setOpen },
  anchorRef,
) => {
  const { notificacoes } = useContext(GlobalContext)

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return
    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false) anchorRef.current.focus()
    prevOpen.current = open
  }, [anchorRef, open])

  return (
    <Popper
      style={{ marginTop: 0, zIndex: 99 }}
      open={open}
      anchorEl={anchorRef.current}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Slide
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper style={{ padding: 5, zIndex: 99 }}>
            <ClickAwayListener
              style={{ marginTop: 120, zIndex: 99 }}
              onClickAway={handleClose}
            >
              <MenuList autoFocusItem={open} onKeyDown={handleListKeyDown}>
                {notificacoes?.length ? (
                  notificacoes?.map((notificacao) => (
                    <Notificacao
                      key={notificacao.idNotificacao}
                      {...notificacao}
                    />
                  ))
                ) : (
                  <ListItemText
                    style={{
                      paddingLeft: 50,
                      paddingRight: 50,
                      paddingTop: 20,
                      paddingBottom: 10,
                      textAlign: 'center',
                    }}
                    primary="Sem notificações"
                  />
                )}
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Slide>
      )}
    </Popper>
  )
}

export default forwardRef(Notificacoes)
